import React, { useEffect, useState } from "react";
import DivisionCmp from "../../../components/cards/DivisionCmp";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/lab/Skeleton"; // اضافه کردن اسکلتون
import MaterialTextFieldComponent from "../../../components/textField/MaterialTextFieldCmp";
import AutoCompleteSearch from "../../../components/dropdown/AutoCompleteSearch";
import { useMutation } from "react-query";
import { GetCities } from "../../../services/basicInformation.service";
import { GetCitiesResponse } from "../../../models/basicInformation.model";
import TextPhone from "../../../components/textField/TextPhone";
import MapPint from "../../map/mapPoint";
import CustomizeSwitch from "../../../components/switch/customizeSwitch";
import TextFeildBadge from "../../../components/textField/TextFeildBadge";
import { Button } from "@mui/material";

const BranchRegisterSkeleton = () => {
  return (
    <Grid container spacing={3} sx={{ padding: "15px 30px" }}>
      <Grid item xs={12} md={6} container>
        <Grid item xs={12} sx={{ marginBottom: "16px" }}>
          <Skeleton variant="rectangular" width="100%" height={50} />
        </Grid>

        <Grid item xs={12} sx={{ marginBottom: "16px" }} container>
          <Grid xs={3} marginTop={"10px"}>
            <Skeleton variant="text" width="100%" />
          </Grid>
          <Grid xs={1}></Grid>
          <Grid xs={8} textAlign="right">
            <Skeleton variant="rectangular" width="100%" height={60} />
          </Grid>
        </Grid>

        <Grid item xs={12} container spacing={2} sx={{ marginBottom: "16px" }}>
          <Grid item xs={8}>
            <Skeleton variant="rectangular" width="100%" height={60} />
          </Grid>
          <Grid item xs={4}>
            <Skeleton variant="rectangular" width="100%" height={60} />
          </Grid>
        </Grid>

        <Grid item xs={12} sx={{ marginBottom: "16px" }}>
          <Skeleton variant="rectangular" width="100%" height={50} />
        </Grid>

        <Grid item xs={12} sx={{ marginBottom: "16px" }}>
          <Skeleton variant="rectangular" width="100%" height={60} />
        </Grid>

        <>
          <Grid item xs={12} sx={{ marginBottom: "16px" }}>
            <Skeleton variant="rectangular" width="100%" height={50} />
          </Grid>
          <Grid item xs={12} sx={{ marginBottom: "16px" }}>
            <Skeleton variant="rectangular" width="100%" height={60} />
          </Grid>
        </>
        <Grid item xs={12} sx={{ marginBottom: "16px" }}>
          <Skeleton variant="rectangular" width="100%" height={60} />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default BranchRegisterSkeleton;
